
import $ from 'jquery';
import '../../../../node_modules/isotope-layout/dist/isotope.pkgd';

$('.btnFilterList').on( 'click', 'button', function() {
  var filterValue = $(this).attr('data-filter');
  var $layout = $(this).parent().next().isotope({
      itemSelector: '.item',
      layoutMode: 'fitRows',
    });
  $layout.isotope({ filter: filterValue });
});

// change is-checked class on buttons
$('.btnFilterList').each( function( i, buttonGroup ) {
  var $buttonGroup = $(buttonGroup );
  $buttonGroup.on( 'click', 'button', function() {
    $buttonGroup.find('.is-checked').removeClass('is-checked');
    $(this).addClass('is-checked');
  });
});
